var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _path12, _g5, _path13, _g6, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 2,
    width: 7,
    height: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0564 2.35959L24.7261 2.6453C24.9365 2.61946 25.1583 2.60625 25.3912 2.60554C26.4599 2.60256 27.3202 2.86507 27.9691 3.39104L30.2994 3.10527C29.6505 2.5793 28.7902 2.31687 27.7215 2.31985C27.4886 2.32053 27.2668 2.33375 27.0564 2.35959Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0564 2.35943L24.7261 2.64515C24.7553 2.64154 24.7848 2.6382 24.8146 2.63508L27.1449 2.34937C27.1151 2.35249 27.0856 2.35582 27.0564 2.35943Z",
    fill: "url(#paint0_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1472 2.34952L24.8169 2.63523C25.0008 2.61604 25.193 2.60611 25.3936 2.60554C25.5526 2.60514 25.707 2.61056 25.8567 2.62188L28.1871 2.33616C28.0373 2.32484 27.8829 2.31942 27.7239 2.31985C27.5233 2.32039 27.3311 2.33033 27.1472 2.34952Z",
    fill: "url(#paint1_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1834 2.33667L25.853 2.62239C26.3292 2.65832 26.7586 2.75356 27.141 2.90797L29.4713 2.62225C29.0889 2.46787 28.6595 2.37261 28.1834 2.33667Z",
    fill: "url(#paint2_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4734 2.62256L27.1431 2.90828C27.3677 2.99893 27.5761 3.11005 27.7681 3.2415L30.0984 2.9558C29.9064 2.82434 29.698 2.71324 29.4734 2.62256Z",
    fill: "url(#paint3_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0988 2.95508L27.7686 3.24078C27.8379 3.28825 27.9052 3.33835 27.9703 3.39113L30.3005 3.10536C30.2354 3.05262 30.1682 3.00253 30.0988 2.95508Z",
    fill: "url(#paint4_linear_1404_42136)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 3,
    width: 6,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4219 9.52975L28.7522 9.24397C29.5067 9.15149 30.1167 8.89767 30.5808 8.48314C31.1774 7.95361 31.4414 7.05639 31.3754 5.79237C31.3096 4.52932 30.9522 3.63377 30.3005 3.10584L27.9702 3.39161C28.6219 3.91949 28.9793 4.81503 29.0451 6.07808C29.1111 7.3421 28.8471 8.23932 28.2505 8.76885C27.7864 9.18338 27.1764 9.4372 26.4219 9.52975Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.302 3.10584L27.9717 3.39161C28.0732 3.47382 28.1676 3.56496 28.2548 3.66509L30.5851 3.37939C30.4979 3.27927 30.4035 3.1881 30.302 3.10584Z",
    fill: "url(#paint5_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5836 3.37891L28.2533 3.6646C28.7262 4.207 28.9895 5.01132 29.0451 6.07759C29.1111 7.34161 28.8471 8.23884 28.2505 8.76836C27.7864 9.18289 27.1764 9.43671 26.4219 9.52926L28.7522 9.24348C29.5067 9.151 30.1167 8.89718 30.5808 8.48265C31.1774 7.95312 31.4414 7.0559 31.3754 5.79188C31.3199 4.72562 31.0565 3.92119 30.5836 3.37891Z",
    fill: "url(#paint6_linear_1404_42136)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2981 22.1716L29.9678 22.4573L27.1094 23.6879L29.4397 23.4022L32.2981 22.1716Z",
    fill: "url(#paint7_linear_1404_42136)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 12,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8212 0.104249L23.4909 0.389967C21.9329 0.581043 20.6987 1.03482 19.7894 1.75174C18.5582 2.72253 17.9936 4.17457 18.0945 6.10897C18.1953 8.04335 18.911 9.49185 20.2431 10.4554C21.5752 11.419 23.4525 11.8969 25.8726 11.8901C26.5057 11.8884 27.0982 11.8536 27.6499 11.786L29.9802 11.5003C29.4285 11.5679 28.836 11.6027 28.2029 11.6044C25.7828 11.6112 23.9055 11.1333 22.5734 10.1697C21.2413 9.20614 20.5256 7.75764 20.4248 5.82326C20.3239 3.88886 20.8885 2.43684 22.1197 1.46602C23.029 0.7491 24.2632 0.295325 25.8212 0.104249Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8212 0.104249L23.4909 0.389967C21.9329 0.581043 20.6987 1.03482 19.7894 1.75174C18.5582 2.72253 17.9936 4.17457 18.0945 6.10897C18.1714 7.58519 18.6065 8.77848 19.4004 9.68918L21.7307 9.4034C20.9368 8.4927 20.5017 7.29948 20.4248 5.82326C20.3239 3.88886 20.8885 2.43684 22.1197 1.46602C23.029 0.7491 24.2632 0.295325 25.8212 0.104249Z",
    fill: "url(#paint8_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7317 9.40344L19.4014 9.68922C19.6477 9.97181 19.9286 10.2272 20.2441 10.4555C20.2844 10.4846 20.3251 10.5132 20.3663 10.5415L22.6966 10.2557C22.6554 10.2275 22.6147 10.1989 22.5744 10.1698C22.2589 9.94151 21.978 9.6861 21.7317 9.40344Z",
    fill: "url(#paint9_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7014 10.2556L20.3711 10.5414C20.7413 10.7947 21.1516 11.0124 21.602 11.1944L23.9323 10.9086C23.4819 10.7267 23.0716 10.509 22.7014 10.2556Z",
    fill: "url(#paint10_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9289 10.9091L21.5986 11.1948C22.4622 11.5437 23.4731 11.7613 24.6308 11.8478L26.9611 11.5621C25.8034 11.4756 24.7925 11.258 23.9289 10.9091Z",
    fill: "url(#paint11_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9607 11.5619L24.6304 11.8476C25.0278 11.8772 25.4425 11.8915 25.8745 11.8902C26.4221 11.8887 26.9393 11.8626 27.426 11.8117L29.7563 11.526C29.2696 11.5769 28.7524 11.603 28.2048 11.6045C27.7728 11.6058 27.3581 11.5915 26.9607 11.5619Z",
    fill: "url(#paint12_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7546 11.5262L27.4243 11.8119C27.5003 11.804 27.5756 11.7954 27.6502 11.7863L29.9805 11.5006C29.9059 11.5097 29.8306 11.5183 29.7546 11.5262Z",
    fill: "url(#paint13_linear_1404_42136)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2989 3.10593C30.9506 3.63386 31.3081 4.52942 31.3739 5.79246C31.4398 7.05648 31.1758 7.95371 30.5793 8.48323C29.9854 9.01366 29.1528 9.28089 28.0841 9.28388C27.0167 9.28686 26.1578 9.02436 25.5062 8.49748C24.856 7.97143 24.4972 7.07594 24.4313 5.81192C24.3655 4.54885 24.6307 3.65164 25.2259 3.12018C25.8224 2.59073 26.6537 2.3235 27.7211 2.32051C28.7898 2.31753 29.65 2.57996 30.2989 3.10593ZM33.6833 10.1384C34.9145 9.16763 35.4804 7.71559 35.3795 5.78121C35.2787 3.84681 34.5616 2.39832 33.2295 1.43475C31.8974 0.47117 30.0215 -0.00673668 27.6002 7.23699e-05C25.1801 0.00688837 23.3532 0.495133 22.1219 1.46593C20.8907 2.43676 20.3261 3.88877 20.427 5.82317C20.5278 7.75756 21.2435 9.20606 22.5756 10.1696C23.9077 11.1332 25.785 11.6111 28.2051 11.6043C30.6264 11.5975 32.4521 11.1092 33.6833 10.1384Z",
    fill: "#10BD89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 26.0859L20.8721 26.3716L30.3689 30.2317L32.6992 29.946L23.2024 26.0859Z",
    fill: "url(#paint14_linear_1404_42136)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8788 24.9337L23.5485 25.2194L20.8721 26.3709L23.2024 26.0852L25.8788 24.9337Z",
    fill: "url(#paint15_linear_1404_42136)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5336 0.433838L8.20329 0.719556L4.62939 2.22954L6.95969 1.94383L10.5336 0.433838Z",
    fill: "url(#paint16_linear_1404_42136)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6979 29.9454L32.2927 22.172L29.4342 23.4025L10.5295 0.433838L6.95557 1.94383L25.8775 24.9338L23.201 26.0853L32.6979 29.9454Z",
    fill: "#10BD89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95969 1.94385L4.62939 2.22957L23.5513 25.2196L25.8816 24.9339L6.95969 1.94385Z",
    fill: "url(#paint17_linear_1404_42136)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 18,
    width: 6,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74826 18.6576L7.41797 18.9433C7.62879 18.9175 7.85089 18.9042 8.08428 18.9036C9.15165 18.9005 10.0119 19.1631 10.6621 19.689L12.9924 19.4033C12.3422 18.8773 11.4819 18.6148 10.4146 18.6178C10.1812 18.6185 9.95908 18.6318 9.74826 18.6576Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74826 18.659L7.41797 18.9447C7.44731 18.9411 7.47674 18.9378 7.50654 18.9346L9.83683 18.6489C9.80713 18.6521 9.7776 18.6554 9.74826 18.659Z",
    fill: "url(#paint18_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83274 18.6476L7.50244 18.9333C7.68663 18.914 7.87921 18.9042 8.08019 18.9036C8.23882 18.9031 8.39294 18.9085 8.54246 18.9198L10.8727 18.6341C10.7232 18.6228 10.5691 18.6174 10.4105 18.6178C10.2095 18.6184 10.0169 18.6283 9.83274 18.6476Z",
    fill: "url(#paint19_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8747 18.6346L8.54443 18.9204C9.02042 18.9563 9.45001 19.0516 9.83273 19.2062L12.1631 18.9204C11.7803 18.7659 11.3508 18.6706 10.8747 18.6346Z",
    fill: "url(#paint20_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1653 18.9207L9.83496 19.2064C10.0602 19.2974 10.2693 19.4088 10.4621 19.5407L12.7924 19.255C12.5996 19.1231 12.3905 19.0116 12.1653 18.9207Z",
    fill: "url(#paint21_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7907 19.2544L10.4604 19.5401C10.5292 19.5872 10.596 19.6369 10.6606 19.6892L12.9909 19.4035C12.9263 19.3512 12.8595 19.3015 12.7907 19.2544Z",
    fill: "url(#paint22_linear_1404_42136)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 6,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11377 25.8266L11.4441 25.5409C12.1975 25.4486 12.8073 25.1954 13.2723 24.781C13.8674 24.2505 14.1327 23.3533 14.0669 22.0903C14.001 20.8263 13.6423 19.9308 12.9919 19.4038L10.6616 19.6895C11.3119 20.2165 11.6707 21.112 11.7366 22.376C11.8024 23.639 11.5371 24.5363 10.942 25.0668C10.477 25.4811 9.86721 25.7343 9.11377 25.8266Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9875 19.4038L10.6572 19.6895C10.7585 19.7716 10.8527 19.8626 10.9398 19.9625L13.2701 19.6768C13.183 19.5769 13.0888 19.4859 12.9875 19.4038Z",
    fill: "url(#paint23_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2745 19.677L10.9442 19.9627C11.4166 20.5045 11.681 21.309 11.7366 22.3762C11.8024 23.6392 11.5371 24.5365 10.942 25.0669C10.477 25.4813 9.86721 25.7345 9.11377 25.8268L11.4441 25.5411C12.1975 25.4488 12.8073 25.1956 13.2723 24.7812C13.8674 24.2507 14.1327 23.3535 14.0669 22.0905C14.0113 21.0233 13.7469 20.2188 13.2745 19.677Z",
    fill: "url(#paint24_linear_1404_42136)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1404_42136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 13,
    height: 13
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51635 16.4009L6.18605 16.6866C4.6269 16.8778 3.39277 17.3322 2.48313 18.0494C1.25181 19.0192 0.685983 20.4723 0.786833 22.4066C0.887592 24.3401 1.60474 25.7895 2.93682 26.7531C4.26882 27.7157 6.14488 28.1947 8.56628 28.1879C9.19873 28.186 9.79056 28.1514 10.3419 28.0838L12.6721 27.7981C12.1209 27.8656 11.529 27.9003 10.8966 27.9021C8.47518 27.9089 6.59912 27.43 5.26712 26.4674C3.93503 25.5038 3.21788 24.0544 3.11712 22.1209C3.01627 20.1866 3.5821 18.7335 4.81343 17.7637C5.72307 17.0464 6.95719 16.592 8.51635 16.4009Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1404_42136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51635 16.4009L6.18605 16.6866C4.6269 16.8778 3.39277 17.3321 2.48313 18.0494C1.25181 19.0192 0.685983 20.4723 0.786833 22.4066C0.863757 23.882 1.29948 25.0754 2.09346 25.9863L4.42375 25.7006C3.62977 24.7897 3.19405 23.5962 3.11712 22.1209C3.01627 20.1866 3.5821 18.7335 4.81343 17.7637C5.72307 17.0464 6.95719 16.592 8.51635 16.4009Z",
    fill: "url(#paint25_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42405 25.7014L2.09375 25.9871C2.34032 26.27 2.62148 26.5256 2.93712 26.7539C2.97702 26.7828 3.01747 26.8112 3.05837 26.8392L5.38867 26.5535C5.34777 26.5255 5.30732 26.4971 5.26741 26.4682C4.95177 26.2399 4.67062 25.9843 4.42405 25.7014Z",
    fill: "url(#paint26_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38742 26.5535L3.05713 26.8392C3.42766 27.0927 3.83829 27.3105 4.28909 27.4927L6.61947 27.2069C6.16858 27.0248 5.75796 26.8069 5.38742 26.5535Z",
    fill: "url(#paint27_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6214 27.2057L4.29102 27.4914C5.1547 27.8403 6.16564 28.0582 7.32401 28.1447L9.6543 27.859C8.49593 27.7725 7.48499 27.5546 6.6214 27.2057Z",
    fill: "url(#paint28_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65256 27.8597L7.32227 28.1454C7.71935 28.1751 8.13376 28.1893 8.56551 28.1881C9.11246 28.1866 9.62899 28.1604 10.1152 28.1097L12.4455 27.824C11.9593 27.8747 11.4428 27.9008 10.8958 27.9023C10.4641 27.9036 10.0496 27.8894 9.65256 27.8597Z",
    fill: "url(#paint29_linear_1404_42136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4465 27.8242L10.1162 28.1099C10.1922 28.1019 10.2675 28.0935 10.3421 28.0843L12.6724 27.7986C12.5978 27.8077 12.5225 27.8162 12.4465 27.8242Z",
    fill: "url(#paint30_linear_1404_42136)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9926 19.4035C13.643 19.9304 14.0017 20.8259 14.0676 22.0899C14.1334 23.353 13.8681 24.2502 13.273 24.7807C12.6778 25.3111 11.8451 25.5774 10.7777 25.5804C9.70909 25.5834 8.8502 25.3219 8.19996 24.795C7.54962 24.268 7.19082 23.3725 7.125 22.1094C7.0591 20.8454 7.32445 19.9482 7.91961 19.4177C8.51487 18.8882 9.34605 18.621 10.4148 18.618C11.4821 18.615 12.3424 18.8775 12.9926 19.4035ZM16.377 26.4359C17.6082 25.4652 18.1727 24.0121 18.0719 22.0787C17.971 20.1443 17.2552 18.6948 15.9232 17.7322C14.5912 16.7686 12.7151 16.2898 10.2938 16.2966C7.8724 16.3034 6.04681 16.7926 4.81566 17.7634C3.58433 18.7333 3.0185 20.1863 3.11935 22.1207C3.22011 24.0541 3.93726 25.5035 5.26935 26.4671C6.60134 27.4297 8.47741 27.9086 10.8988 27.9018C13.3201 27.895 15.1457 27.4058 16.377 26.4359Z",
    fill: "#10BD89"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_42136",
    x1: 24.7261,
    y1: 2.49726,
    x2: 27.1449,
    y2: 2.49726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_42136",
    x1: 24.8169,
    y1: 2.47753,
    x2: 28.1871,
    y2: 2.47753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_42136",
    x1: 25.853,
    y1: 2.62232,
    x2: 29.4713,
    y2: 2.62232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1404_42136",
    x1: 27.1431,
    y1: 2.93203,
    x2: 30.0984,
    y2: 2.93203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1404_42136",
    x1: 27.7686,
    y1: 3.17311,
    x2: 30.3005,
    y2: 3.17311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1404_42136",
    x1: 27.9717,
    y1: 3.38546,
    x2: 30.5851,
    y2: 3.38546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1404_42136",
    x1: 26.4219,
    y1: 6.45408,
    x2: 31.3853,
    y2: 6.45408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1404_42136",
    x1: 27.1094,
    y1: 22.9298,
    x2: 32.2981,
    y2: 22.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1404_42136",
    x1: 18.083,
    y1: 4.89671,
    x2: 25.8212,
    y2: 4.89671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1404_42136",
    x1: 19.4014,
    y1: 9.97247,
    x2: 22.6966,
    y2: 9.97247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1404_42136",
    x1: 20.3711,
    y1: 10.725,
    x2: 23.9323,
    y2: 10.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1404_42136",
    x1: 21.5986,
    y1: 11.3784,
    x2: 26.9611,
    y2: 11.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1404_42136",
    x1: 24.6304,
    y1: 11.7082,
    x2: 29.7563,
    y2: 11.7082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1404_42136",
    x1: 27.4243,
    y1: 11.6563,
    x2: 29.9805,
    y2: 11.6563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1404_42136",
    x1: 20.8721,
    y1: 28.1588,
    x2: 32.6992,
    y2: 28.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1404_42136",
    x1: 20.8721,
    y1: 25.6523,
    x2: 25.8788,
    y2: 25.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1404_42136",
    x1: 4.62939,
    y1: 1.33169,
    x2: 10.5336,
    y2: 1.33169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1404_42136",
    x1: 4.62939,
    y1: 13.5817,
    x2: 25.8816,
    y2: 13.5817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1404_42136",
    x1: 7.41797,
    y1: 18.7968,
    x2: 9.83683,
    y2: 18.7968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1404_42136",
    x1: 7.50244,
    y1: 18.7755,
    x2: 10.8727,
    y2: 18.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1404_42136",
    x1: 8.54443,
    y1: 18.9204,
    x2: 12.1631,
    y2: 18.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1404_42136",
    x1: 9.83496,
    y1: 19.2307,
    x2: 12.7924,
    y2: 19.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1404_42136",
    x1: 10.4604,
    y1: 19.4718,
    x2: 12.9909,
    y2: 19.4718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1404_42136",
    x1: 10.6572,
    y1: 19.6832,
    x2: 13.2701,
    y2: 19.6832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1404_42136",
    x1: 9.11377,
    y1: 22.7519,
    x2: 14.0767,
    y2: 22.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1404_42136",
    x1: 0.77539,
    y1: 21.1936,
    x2: 8.51635,
    y2: 21.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1404_42136",
    x1: 2.09375,
    y1: 26.2703,
    x2: 5.38867,
    y2: 26.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1404_42136",
    x1: 3.05713,
    y1: 27.0231,
    x2: 6.61947,
    y2: 27.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1404_42136",
    x1: 4.29102,
    y1: 27.6752,
    x2: 9.6543,
    y2: 27.6752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1404_42136",
    x1: 7.32227,
    y1: 28.0061,
    x2: 12.4455,
    y2: 28.0061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1404_42136",
    x1: 10.1162,
    y1: 27.9543,
    x2: 12.6724,
    y2: 27.9543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDown);
export default __webpack_public_path__ + "static/media/percentDown.4e75f7a6e4248cc7bf7a1dd5e2f8b846.svg";
export { ForwardRef as ReactComponent };